module.exports = __webpack_public_path__ + "img/turbo_on.359802c8.png";